import { Inputfiledsbase } from './models/inputfiledsbase';

export class TimepickerQuestion extends Inputfiledsbase<string> {
  override controlType = 'timepicker';
}